import {
  deleteSupplier,
  exportBankCardCheckResult,
  exportBankCardList,
  getBankCardCheckResult,
  getBankCardExportResult,
  getSupplierList,
  saveSupplier,
  updateSupplier,
} from '../services';

export default {
  namespace: 'supplier',
  state: {},
  effects: {
    *getSupplierList({ payload }, { call }) {
      const result = yield call(getSupplierList, payload);
      return result;
    },

    *saveSupplier({ payload }, { call }) {
      const result = yield call(saveSupplier, payload);
      return result;
    },

    *updateSupplier({ payload }, { call }) {
      const result = yield call(updateSupplier, payload);
      return result;
    },

    *deleteSupplier({ payload }, { call }) {
      const result = yield call(deleteSupplier, payload);
      return result;
    },

    *exportBankCardList({ payload }, { call }) {
      const result = yield call(exportBankCardList, payload);
      return result;
    },

    *getBankCardExportResult({ payload }, { call }) {
      const result = yield call(getBankCardExportResult, payload);
      return result;
    },
    *exportBankCardCheckResult({ payload }, { call }) {
      const result = yield call(exportBankCardCheckResult, payload);
      return result;
    },

    *getBankCardCheckResult({ payload }, { call }) {
      const result = yield call(getBankCardCheckResult, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
